import styled from '@emotion/styled'

import ModalManager from 'components/ModalManager'
import { useAppStore } from 'lib/store'

const BlankModal = styled(ModalManager)`
	padding: 0;
	background-color: inherit;
	border-radius: ${({ theme }) => theme.borderRadiuses.xxl};
	max-width: unset;
	aspect-ratio: 16/9;
	width: 60%;
`

const VideoIframe = styled.iframe`
	height: 100%;
	width: 100%;
	border-radius: inherit;
`

type Props = {
	src: string
}

function YouTubeVideoModal({ src }: Props) {
	const store = useAppStore()

	return (
		<BlankModal
			modalName="YouTubeVideoModal"
			hideModal={() => store.dispatch({ type: 'currentModal/set', payload: null })}
		>
			<VideoIframe
				src={src}
				title="YouTube video player"
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				allowFullScreen
			/>
		</BlankModal>
	)
}

export default YouTubeVideoModal
